import { render } from "./News-Details.vue?vue&type=template&id=0911d5fc&scoped=true"
import script from "./News-Details.vue?vue&type=script&lang=js"
export * from "./News-Details.vue?vue&type=script&lang=js"

import "./News-Details.vue?vue&type=style&index=0&id=0911d5fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0911d5fc"

export default script